import { createSearchParams } from 'react-router-dom';

const useNavigateSearch = () => {
  return (params: any) => `?${createSearchParams(params)}`;
};

export default useNavigateSearch;
